import * as React from 'react';
import Typography from '@mui/material/Typography';

/** セクション見出しの上に置く英字ラベル（Our Values / Concept / Works）。 */
export default function Eyebrow({ children, sx, ...other }) {
  return (
    <Typography component="p" sx={{ typography: 'eyebrow', color: 'green', mb: 2, ...sx }} {...other}>
      {children}
    </Typography>
  );
}
